import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=122deb7d&scoped=true&lang=pug&"
import script from "./modal.ts?vue&type=script&lang=ts&"
export * from "./modal.ts?vue&type=script&lang=ts&"
import style0 from "./modal.vue?vue&type=style&index=0&id=122deb7d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122deb7d",
  null
  
)

export default component.exports